import FormService from "../../services/FormService";
import FormInput from '../../components/FormInput';
import SelectPicker from '../../components/SelectPicker';
import Pagination from "../../components/Pagination";
import {ModelListSelect} from 'vue-search-select';

export default {
    components: {
        FormInput,
        SelectPicker,
        ModelListSelect,
        Pagination
    },
    data() {
        return {
            form: new FormService({
                name: null,
                email: null,
                old_password: null,
                password: null,
                confirm_password: null,
                type: null,
                status: null,
                user_role: null,
                phone: null,
                can_edit_user: false,
            }),
            user_type: -1,
            user_types: [],
            user_roles: [],
            selected_user_roles: [],
            selected_user_name: '',
            selected_user_type: null,
            keyword: '',
            selected_user_id: '',
            modelList: [],
            modelStatuses: [],
            status: 10,
            editing_status: 0,
            can_edit_user: false,
            page: 1,
            links: {},
            keywordSearchTimeout: null,
        }
    },
    methods: {
        Create() {
            this.editing_status = 0;
            this.form.post('users.create')
                .then(res => {
                    if (!res.errors) {
                        $('#exampleModal').modal('hide');
                        this.GetAll();
                        this.$store.commit('successNotify');
                    }
                });
        },
        Read(id) {
            this.editing_status = 1;
            this.$api.get('users.show', id)
                .then(res => {
                    // console.log(res);
                    this.form.setData(res.data);
                    this.form.password = '';
                    $('#exampleModal').modal('show');
                });
        },
        Role(id) {
            this.$api.get('users.show', id)
                .then(res => {
                    this.form.setData(res.data);
                    $('#roleModal').modal('show');
                });
        },
        Update() {
            this.form.put('users.update', this.form.id)
                .then(res => {
                    if (!res.errors) {
                        $('#exampleModal').modal('hide');
                        this.GetAll();
                        this.$store.commit('successNotify');
                    }
                });
        },
        Delete(id) {
            if (confirm('You are about to delete the record! \nAre you sure?')) {
                this.$api.delete('users.delete', id)
                    .then(res => {
                        if (!res.errors) {
                            this.GetAll();
                            this.$store.commit('successNotify');
                        }
                    });
            }
        },
        GetAll() {
            this.$api.get('users.index', {page: this.page, user_type: this.user_type, status: this.status, keyword: this.keyword})
                .then(res => {
                    this.modelList = res.data.users;
                    this.user_types = res.data.user_types;
                    this.modelStatuses = res.data.user_statuses;
                    this.can_edit_user = res.data.can_edit_user;
                    this.form.can_edit_user = res.data.can_edit_user;
                    this.links = res.data.links;
                });
        },
        findType(type) {
            return this.user_types[type];
        },
        searchByKeyword() {
            clearTimeout(this.keywordSearchTimeout);
            this.keywordSearchTimeout = setTimeout(() => {
                this.page = 1;
                this.GetAll();
            }, 400);
        },
        revealRoles(roles = null) {
            let user_roles = '';
            if (roles !== null) {
                let role_length = roles.length;
                let counter = 0;
                roles.forEach(item => {
                    counter++;
                    user_roles = user_roles + item.name + (role_length > counter ? ', ' : '');
                })
            }
            return user_roles;
        },
        getRoles(user_id) {
            this.$api.get('access-control.roles.index')
                .then(res => {
                    this.user_roles = res.data;
                    this.modelList.find((user, index) => {
                        if (user.id === user_id) {
                            user.roles.forEach((role, key) => {
                                this.selected_user_roles.push(role.name);
                            })
                        }
                    });
                });
        },
        giveRole(id, name, type) {
            this.selected_user_roles = [];
            this.getRoles(id);
            this.selected_user_id = id;
            this.selected_user_name = name;
            this.selected_user_type = type;
            $('#roleModal').modal('show');
        },
        attachRoles() {
            let postData = {};
            postData.user_id = this.selected_user_id;
            postData.roles = this.selected_user_roles;
            this.$api.post('users.assign-role', postData).then(data => {
                if (data.status) {
                    this.$store.commit('successNotify');
                    $('#roleModal').modal('hide');
                    this.selected_user_roles = null;
                    this.selected_user_id = null;
                    this.selected_user_type = null;
                    this.selected_user_name = null;
                    this.$router.go(0);
                }
            }).finally(() => {
                this.$router.go(0);
            });
        },
    },
    created() {
        this.page = this.$route.params.page;
        this.GetAll();
    },
    mounted() {
        //this.GetAll();
        $('#exampleModal').on('hidden.bs.modal', (e) => {
            this.form.reset();
        })
    },
    computed: {
        type_list() {
            let types = [{id: -1, name: 'Все типы'}];
            Object.keys(this.user_types).forEach(e => {
                let type = {id: parseInt(e), name: this.user_types[e]};
                types.push(type)
            });
            return types;
        },
        user_status() {
            let types = [{id: -1, name: 'Все статусы'}];
            Object.keys(this.modelStatuses).forEach(e => {
                let type = {id: parseInt(e), name: this.modelStatuses[e]};
                types.push(type)
            });
            return types;
        }
    },
    watch: {
        user_type() {
            this.GetAll();
        },
        status(){
            this.GetAll();
        },
        keyword() {
            this.searchByKeyword();
        }
    },
    beforeRouteUpdate(to, from, next) {
        console.log("before route")
        let page = to.params.page;
        if (page) {
            this.page = page;
            this.GetAll();
        }
        next();
    },
}
